import { generateInternalId } from "@oui/system/utils"
/**
 * The Environment type and default
 */
export type Environment = typeof defaultEnvironment

const defaultEnvironment = {
  generateInternalId,
  Date: () => Date
}

export { defaultEnvironment }
